import { compact, every, omit } from 'lodash';

import { Address as GqlAddress } from '@willow/graphql-iso/src/app';
import { Address as GqlPortalAddress } from '@willow/graphql-iso/src/portal';
import { Address, isUSCountryCode } from '@willow/types-iso';

export function addressToString(address: Address | GqlAddress | GqlPortalAddress, includeCounty?: boolean): string {
  const isAddressEmpty = every(omit(address, ['__typename', 'country']), (v) => v === '' || v == null);
  if (isAddressEmpty) return '';

  const { line1, line2, line3, line4, locality, region, postcode, country } = address;

  if (isUSCountryCode(country)) {
    return `${line1},${line2 ? ` ${line2},` : ''}${line3 ? ` ${line3},` : ''}${
      line4 ? ` ${line4},` : ''
    } ${locality}, ${region} ${postcode}${includeCounty && address.county ? ` (${address.county})` : ''}`;
  }
  return compact([line1, line2, line3, line4, locality, region, postcode, country]).join(', ');
}

export function addressToStringLines(address: Address | GqlAddress): {
  line1: string;
  line2: string;
  line3?: string;
} {
  const { line1, line2, line3, line4, locality, region, postcode, country } = address;

  if (isUSCountryCode(country)) {
    return {
      line1: `${line1}${line2 ? `, ${line2}` : ''}${line3 ? `, ${line3}` : ''}${line4 ? `, ${line4}` : ''}`,
      line2: `${locality}, ${region} ${postcode}`,
    };
  }
  return {
    line1: `${line1}${line2 ? `, ${line2}` : ''}${line3 ? `, ${line3}` : ''}${line4 ? `, ${line4}` : ''}`,
    line2: compact([locality, compact([region, postcode]).join(' '), country]).join(', '),
  };
}
